import React from 'react';
import trafficLightIcon from '../../../images/tracker-light.svg';
import numberIcon from '../../../images/tracker-number.svg';
import fiverIcon from '../../../images/tracker-rating.svg';
import binaryIcon from '../../../images/tracker-yesno.svg';
import { Icon } from '../../ui';

interface TrackerTypeOption {
  className?: string;
  image: string;
  selected: boolean;
  type: string;
  onClick: () => void;
}

interface TrackerTypeOptions {
  selectedType: TrackerType;
  setTrackerType: (value: TrackerType) => void;
}

const TrackerTypeOption: React.FC<TrackerTypeOption> = ({
  className,
  image,
  type,
  selected,
  ...rest
}) => (
  <button
    type="button"
    data-testid={`option-${type}`}
    className={`w-100 flex items-center pv2 pl2 bg-white hover-bg-snow-white ${className}`}
    {...rest}
  >
    <img
      className="db flex-none br b--light-gray pr2"
      style={{ width: 60, height: 36 }}
      src={image}
      alt=""
    />
    <div className="flex justify-between items-center w-100 ph3">
      <p className="f6 mv0">{type}</p>
      {selected && <Icon name="check" size={24} color="navy" />}
    </div>
  </button>
);

const TrackerTypeOptions: React.FC<TrackerTypeOptions> = ({ selectedType, setTrackerType }) => (
  <div className="z-max shadow-1 w-100 mb5 br2 overflow-hidden">
    <TrackerTypeOption
      className="bb b--light-gray"
      type="Rating"
      image={fiverIcon}
      selected={selectedType === 'FIVER'}
      onClick={() => setTrackerType('FIVER')}
    />
    <TrackerTypeOption
      className="bb b--light-gray"
      type="Yes/No"
      image={binaryIcon}
      selected={selectedType === 'BINARY'}
      onClick={() => setTrackerType('BINARY')}
    />
    <TrackerTypeOption
      className="bb b--light-gray"
      type="Number"
      image={numberIcon}
      selected={selectedType === 'INTEGER'}
      onClick={() => setTrackerType('INTEGER')}
    />
    <TrackerTypeOption
      type="Traffic Light"
      image={trafficLightIcon}
      selected={selectedType === 'TRAFFIC_LIGHT'}
      onClick={() => setTrackerType('TRAFFIC_LIGHT')}
    />
  </div>
);

export default TrackerTypeOptions;
